import axios from 'axios';
import { TokenLogout } from 'API/Logout/logout';

const BaseUrl = process.env.REACT_APP_BANKVERIFY_URL;


// stock data
export const stockData = async (fromDate, toDate, product_ids = []) => {
  try {
    const res = await axios.post(
      `${BaseUrl}/maker-checker/api/stocks`,
      {
        fromDate,
        toDate,
        product_ids
      },
      {
        headers: {
          'Content-Type': 'application/json',
          Authorization:`Bearer ${sessionStorage.getItem('token')}`
        }
      }
    );

    if (res.status === 200) {
      return res.data;
    }
  } catch (error) {
    console.error('Error fetching stock data:', error.response?.data || error.message);
    TokenLogout(error);
  }
};




// low device data
export const getLowDevices = async () => {
  try {
    const res = await axios.get(
      `${BaseUrl}/maker-checker/api/low_devices`,
      {
        headers: {
          'Content-Type': 'application/json',
          Authorization:`Bearer ${sessionStorage.getItem('token')}`
        }
      }
    );

    if (res.status === 200) {
      console.log('Low Device API Response:', res.data);
      return res.data;
    }
  } catch (error) {
    console.error('Error fetching low device data:', error.response?.data || error.message);
    TokenLogout(error);
  }
};



// all devices data
export const getAllDevices = async () => {
  try {
    const res = await axios.get(
      `${BaseUrl}/maker-checker/api/devices`,
      {
        headers: {
          'Content-Type': 'application/json',
          Authorization:`Bearer ${sessionStorage.getItem('token')}`
        }
      }
    );

    if (res.status === 200) {
      console.log('All Devices API Response:', res.data);
      return res.data;
    }
  } catch (error) {
    console.error('Error fetching all devices:', error.response?.data || error.message);
    TokenLogout(error);
  }
};




//order recieved from csp api:
export const getOrdersFromCSP = async (fromDate, toDate, product_ids = [], device_name = null) => {
  try {
    const payload = {
      fromDate,
      toDate,
      product_ids,
    };

    // Include device_name if provided
    if (device_name) {
      payload.device_name = device_name;
    }

    console.log("Sending payload to /orders_from_csp:", JSON.stringify(payload, null, 2));

    const res = await axios.post(
      `${BaseUrl}/maker-checker/api/orders_from_csp`,
      payload,
      {
        headers: {
          'Content-Type': 'application/json',
          Authorization:`Bearer ${sessionStorage.getItem('token')}` || ''
        }
      }
    );

    console.log("API Response:", res.data);
    return res.data;
  } catch (error) {
    console.error("Error in getOrdersFromCSP:", error.response?.data || error.message);
    TokenLogout(error);
    return null;
  }
};






// request report data
export const getRequestReport = async () => {
  try {
    const res = await axios.post(
      `${BaseUrl}/maker-checker/api/request_report`,
      {},
      {
        headers: {
          'Content-Type': 'application/json',
          Authorization:`Bearer ${sessionStorage.getItem('token')}`
        }
      }
    );

    if (res.status === 200) {
      console.log('Request Report API Response:', res.data);
      return res.data;
    }
  } catch (error) {
    console.error('Error fetching request report:', error.response?.data || error.message);
    TokenLogout(error);
  }
};




//stock details
export const getStockDetails = async (fromDate, toDate, product_ids = []) => {
  try {
    const payload = {
      product_ids: Array.isArray(product_ids) ? product_ids : [],
      fromDate,
      toDate
    };

    console.log("Sending Stock Details Request with payload:", payload);

    const res = await axios.post(
      `${BaseUrl}/maker-checker/api/stock_details`,
      payload,
      {
        headers: {
          'Content-Type': 'application/json',
          Authorization:`Bearer ${sessionStorage.getItem('token')}`
        }
      }
    );

    if (res.status === 200) {
      return res.data;
    } else {
      console.warn('Non-200 response:', res.status);
      return null;
    }
  } catch (error) {
    console.error('Error fetching stock details:', error.response?.data || error.message);
    TokenLogout(error);
    return null;
  }
};









